import * as RD from "@radix-ui/react-dialog";
import { X } from "lucide-react";
import type { ReactNode } from "react";

interface DialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
  description?: string;
  children: ReactNode;
}

export function Dialog({ open, onOpenChange, title, description, children }: DialogProps) {
  return (
    <RD.Root open={open} onOpenChange={onOpenChange}>
      <RD.Portal>
        <RD.Overlay className="fixed inset-0 z-40 bg-ink/40 backdrop-blur-sm" />
        <RD.Content className="fixed left-1/2 top-1/2 z-50 w-full max-w-md -translate-x-1/2 -translate-y-1/2 rounded-lg border border-ink/10 bg-cream p-6 shadow-xl">
          <div className="flex items-start justify-between">
            <div>
              <RD.Title className="text-lg font-semibold">{title}</RD.Title>
              {description && (
                <RD.Description className="mt-1 text-sm text-ink/65">{description}</RD.Description>
              )}
            </div>
            <RD.Close className="rounded-md p-1 text-ink/45 hover:bg-ink/4 hover:text-ink/65">
              <X size={18} />
            </RD.Close>
          </div>
          <div className="mt-6">{children}</div>
        </RD.Content>
      </RD.Portal>
    </RD.Root>
  );
}
